import { render } from "./MatchedItems.vue?vue&type=template&id=1ce37048"
import script from "./MatchedItems.vue?vue&type=script&lang=js"
export * from "./MatchedItems.vue?vue&type=script&lang=js"

import "./MatchedItems.vue?vue&type=style&index=0&id=1ce37048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__